import React, { Component } from 'react';
import { Rate } from 'antd';
 
class RateField extends Component {
  render() {
    const {input, label, options, meta: { touched, error }, inputProps} = this.props;
    return (
      <div style={{marginBottom: 10, display: 'flex', flexDirection: 'column'}}>
        {label && <label>{label}</label>}
        <Rate {...input} {...inputProps} />
        {touched && ((error && <span style={{color: '#a94442'}}>{error}</span>))}
      </div>
    );
  }
}

export default RateField;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Fields/RateField.jsx